import { TypeAnimation } from "react-type-animation";

const AboutMe = () => {
  return (
    <section className="aboutMe" about="aboutMe" id="aboutMe">
      <h1><strong>Mohamad Mourad</strong></h1>
      <p>
        I am a software developer with professional experience specializing in backend development and web scraping.  
        I enjoy designing and implementing efficient, scalable solutions that solve real-world problems and automate complex tasks.  
        My work combines a strong foundation in computer science principles with practical expertise in building robust applications.  
        I continuously explore new technologies and best practices to stay at the forefront of software development.
      </p>
      <p>
        Some of the technologies I work with include{' '}
        {
          <TypeAnimation
            sequence={[
              'React',
              1000,
              'Flutter',
              1000,
              'Cloude Computing',
              1000,
              'Node',
              1000,
              'Firebase',
              1000,
              'Python',
              1000
            ]}
            wrapper="span"
            speed={50}
            style={{ fontSize: 'inherit', display: 'inline-block', fontWeight: 'bold', color: "#E11D48" }}
            repeat={Infinity}
          />
        }.  
      </p>
    </section>
  );
}

export default AboutMe;
